import { createStyles } from '@mantine/emotion';

export const useUserPickerStyles = createStyles((theme) => ({
  wrapper: {
    borderBottom: theme.other.elements.appBorder,
    padding: `4px ${theme.spacing.xs}`,
  },
}));
